var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account_layout layout"},[_c('router-view',{staticClass:"layout-transition-up"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }